export default __webpack_public_path__ + "static/media/Foto_Oben.a6f98ef0.jpg";